import React from "react";
import format from "date-fns/format";
import compareDesc from "date-fns/compareDesc";
import { publicIpv4 } from "public-ip";
import { Netmask } from "netmask";
import { ClientJS } from "clientjs";
import { RESOLUTIONS } from "services/config";
import { TICKET_LIST_CYCLE_DIRECTION } from "../utils/TicketConstants";
import { NotificationIcon } from "../sub_components/Layout/Footer/Components/ReleaseNotes/Components/NotificationIcon";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const Atlanta = `${CDN_URL}profile/image-building-atlanta.svg`;
const Huntsville = `${CDN_URL}profile/image-building-huntsville.svg`;
const Chattanooga = `${CDN_URL}profile/images-building-chattanooga.svg`;
const Birmingham = `${CDN_URL}profile/image-building-birmingham.svg`;
const MultiLocations = `${CDN_URL}profile/Multi-Location.svg`;
const NavTopAccount = `${CDN_URL}navigation/nav-top-triangle-account.svg`;
const NavTopAccountmd = `${CDN_URL}navigation/nav-top-triangle-account-md.svg`;
const NavBottomAccount = `${CDN_URL}navigation/nav-bottom-triangle-account.svg`;
const NavTopColo = `${CDN_URL}navigation/nav-top-triangle-colo.svg`;
const NavBottomColo = `${CDN_URL}navigation/nav-bottom-triangle-colo.svg`;
const NavTopBilling = `${CDN_URL}navigation/nav-top-triangle-billing.svg`;
const NavTopBillingmd = `${CDN_URL}navigation/nav-top-triangle-billing-md.svg`;
const NavBottomBilling = `${CDN_URL}navigation/nav-bottom-triangle-billling.svg`;
const NavTopSupport = `${CDN_URL}navigation/nav-top-triangle-support.svg`;
const NavTopSupportmd = `${CDN_URL}navigation/nav-top-triangle-support-md.svg`;
const NavBottomSupport = `${CDN_URL}navigation/nav-bottom-triangle-support.svg`;
const NavTopStorage = `${CDN_URL}navigation/nav-top-triangle-storage.svg`;
const NavTopStoragemd = `${CDN_URL}navigation/nav-top-triangle-storage-md.svg`;
const NavBottomStorage = `${CDN_URL}navigation/nav-bottom-triangle-storage.svg`;

export const SIDES = {
  LEFT: "left",
  RIGHT: "right",
};

export const SERVICE_IDS = {
  4: "billing",
  2: "support",
  1: "storage",
  3: "account",
};

export class Utils {
  static getMenuItems = (names) => {
    const menu = [];
    for (let i = 0; i <= names.length - 1; i++) {
      menu.push({ name: names[i] });
    }
    return menu;
  };
  static getNotificationIcon = (module, text, breakpoint) => {
    let fontSize = "13px";
    if (RESOLUTIONS.MED === breakpoint) {
      fontSize = "14px";
    } else if (RESOLUTIONS.HIGH === breakpoint) {
      fontSize = "16px";
    }

    switch (module) {
      case "ACCOUNT":
        return (
          <NotificationIcon text={text} fill={"#2a7de1"} fontSize={fontSize} />
        );
      case "SUPPORT":
        return (
          <NotificationIcon text={text} fill={"#9164cc"} fontSize={fontSize} />
        );
      case "STORAGE":
        return (
          <NotificationIcon text={text} fill={"#008388"} fontSize={fontSize} />
        );
      case "BILLING":
        return (
          <NotificationIcon text={text} fill={"#a8ad00"} fontSize={fontSize} />
        );
      case "COLOCATION":
        return (
          <NotificationIcon text={text} fill={"#00AD5C"} fontSize={fontSize} />
        );
      case "COLO":
        return (
          <NotificationIcon text={text} fill={"#00AD5C"} fontSize={fontSize} />
        );
      default:
        return (
          <NotificationIcon text={text} fill={"#cfd2d3"} fontSize={fontSize} />
        );
    }
  };

  static removeScroll = () => {
    const mainContent = document.querySelector(".main-content");

    if (mainContent) {
      mainContent.classList.add("no-scroll");
    }
  };
  static addScroll = () => {
    const mainContent = document.querySelector(".main-content");

    if (mainContent) {
      mainContent.classList.remove("no-scroll");
    }
  };

  static getClearanceLevel = (clearance) => {
    let description = "";
    switch (clearance) {
      case "1" || 1:
        description = "Gate Access";
        break;
      case "2" || 2:
        description = "Gate and Hut Access";
        break;
      default:
        description = "Unknown";
        break;
    }
    return description;
  };

  static getPriority = (priority) => {
    let prioityInt = 4;

    switch (priority) {
      case "low":
        prioityInt = 4;
        break;
      case "medium":
        prioityInt = 3;
        break;
      case "high":
        prioityInt = 2;
        break;
      default:
        prioityInt = 3;
        break;
    }
    return prioityInt;
  };

  static getPriorityString = (priority) => {
    let prioityInt = "Low";

    switch (priority) {
      case 4:
        prioityInt = "Low";
        break;
      case 3:
        prioityInt = "Medium";
        break;
      case 2:
        prioityInt = "High";
        break;
      default:
        prioityInt = "Low";
        break;
    }
    return prioityInt;
  };

  static showModalBackdropMain = () => {
    const mainPortal = document.querySelector(".main-portal-modal-overlay");

    if (mainPortal) {
      mainPortal.classList.add("show");
    }
  };
  static removeModalBackdropMain = () => {
    const mainPortal = document.querySelector(".main-portal-modal-overlay");

    if (mainPortal) {
      mainPortal.classList.remove("show");
    }
  };

  static showHorizontalBar = () => {
    const bar = document.querySelector(".horizontal-bar");
    const interiorWall = document.querySelector(".interior-wall");
    if (bar && interiorWall) {
      bar.classList.add("show");
      interiorWall.classList.add("show");
    }
  };
  static removeHorizontalBar = () => {
    const bar = document.querySelector(".horizontal-bar");
    const interiorWall = document.querySelector(".interior-wall");
    if (bar && interiorWall) {
      bar.classList.remove("show");
      interiorWall.classList.remove("show");
    }
  };
  //Get menu number based on module
  static getModuleNumber = (module) => {
    let moduleNumber = null;

    switch (module) {
      case "colocation":
        moduleNumber = 5;
        break;
      case "billing":
        moduleNumber = 4;
        break;
      case "account":
        moduleNumber = 3;
        break;
      case "support":
        moduleNumber = 2;
        break;
      case "storage":
        moduleNumber = 1;
        break;
      default:
        moduleNumber = "";

        break;
    }

    return moduleNumber;
  };
  static getClientIp() {
    const ipv4 = publicIpv4() || "";
    return ipv4;
  }
  static async getClientParams(site) {
    const ip = await Utils.getClientIp();
    const clientJs = new ClientJS();
    const browser = `Browser Type: ${clientJs.getBrowser() || "Unknown"}\n`;
    const browserVersion = `Browser Version: ${
      clientJs.getBrowserVersion() || "Unknown"
    }\n`;
    const currentResolution = `Current Resolution: ${
      clientJs.getCurrentResolution() || "Unknown"
    }\n`;
    const screenPrint = `Screen Print: ${
      clientJs.getScreenPrint() || "Unknown"
    }\n`;
    const windowSize = `Window size: ${window.innerWidth || "??"} x ${
      window.innerHeight || "??"
    }\n`;
    const OS = `OS: ${clientJs.getOS() || "Unknown"}\n`;
    const OsVersion = `OS Version: ${clientJs.getOSVersion() || "Unknown"}\n`;
    const timeZone = `Time Zone: ${clientJs.getTimeZone() || "Unknown"}\n`;
    const language = `Language: ${clientJs.getLanguage() || "Unknown"}\n`;
    const publicIp = `Public Ip Address: ${ip || "Unknown"}\n`;
    const siteModule = `On Service: ${site ? site.module : "Unknown"}\n`;
    const sitePage = `On Module: ${site ? site.page : "Unknown"}`;
    return (
      browser +
      browserVersion +
      currentResolution +
      screenPrint +
      windowSize +
      OS +
      OsVersion +
      timeZone +
      language +
      publicIp +
      siteModule +
      sitePage
    );
  }
  static async getIPAddress() {
    const ip = await Utils.getClientIp();
    return ip;
  }
  static getBuildingImage = (locations) => {
    if (!locations) {
      return MultiLocations;
    }
    if (locations.length === 1) {
      const location = locations[0].datacenter;
      if (location === "Atlanta" || location === "ATL") {
        return Atlanta;
      } else if (location === "Chattanooga" || location === "CHA") {
        return Chattanooga;
      } else if (location === "Huntsville" || location === "HSV") {
        return Huntsville;
      } else {
        return Birmingham;
      }
    } else {
      return MultiLocations;
    }
  };
  static getLocationNameByTag = (locationName) => {
    if (locationName === "ATL") {
      return "Atlanta";
    } else if (locationName === "CHA") {
      return "Chattanooga";
    } else if (locationName === "HSV") {
      return "Huntsville";
    } else if (locationName === "BHM") {
      return "Birmingham";
    } else if (locationName === "GSP") {
      return "Greenville";
    } else if (locationName === "MYR") {
      return "Myrtle Beach";
    }
  };

  static getLocationIDByTag = (locationName) => {
    if (locationName === "ATL" || locationName === "atlanta") {
      return 3;
    } else if (locationName === "CHA" || locationName === "chattanooga") {
      return 2;
    } else if (locationName === "HSV" || locationName === "huntsville") {
      return 4;
    } else if (locationName === "BHM" || locationName === "birmingham") {
      return 1;
    } else if (locationName === "GSP" || locationName === "greenville") {
      return 5;
    } else if (locationName === "MYR" || locationName === "myrtle beach") {
      return 6;
    } else return 4;
  };

  static getILALocationID = (locationName) => {
    if (
      locationName.includes("snellville") ||
      locationName.includes("ATL-MYR.P01")
    ) {
      return 1;
    } else if (
      locationName.includes("bishop") ||
      locationName.includes("ATL-MYR.P02")
    ) {
      return 2;
    } else if (
      locationName.includes("crawfordville") ||
      locationName.includes("ATL-MYR.P03")
    ) {
      return 3;
    } else if (
      locationName.includes("grovetown") ||
      locationName.includes("ATL-MYR.P04")
    ) {
      return 4;
    } else if (
      locationName.includes("williston") ||
      locationName.includes("ATL-MYR.P05")
    ) {
      return 5;
    } else if (
      locationName.includes("seneca") ||
      locationName.includes("ATL-MYR.P06")
    ) {
      return 6;
    } else if (
      locationName.includes("corner") ||
      locationName.includes("ATL-MYR.P07")
    ) {
      return 7;
    } else if (
      locationName.includes("georgetown") ||
      locationName.includes("ATL-MYR.P08")
    ) {
      return 8;
    } else return 1;
  };

  static getLocationTagByID = (locationID) => {
    if (locationID === 1) {
      return "ATL";
    } else if (locationID === 2) {
      return "CHA";
    } else if (locationID === 3) {
      return "HSV";
    } else if (locationID === 4) {
      return "BHM";
    } else if (locationID === 5) {
      return "GSP";
    }
  };

  static getCGTicketType(name) {
    if (!name) {
      return "service";
    }
    let type = "service";
    if (
      name.includes("OUTAGE") ||
      name.includes("outage") ||
      name.includes("SUPPORT") ||
      name.includes("Support")
    ) {
      type = "incident";
    }
    return type;
  }

  static setBuildingImageByName = (locationName) => {
    if (locationName === "Atlanta") {
      return Atlanta;
    } else if (locationName === "Chattanooga") {
      return Chattanooga;
    } else if (locationName === "Huntsville") {
      return Huntsville;
    } else if (locationName === "Birmingham") {
      return Birmingham;
    } else {
      return MultiLocations;
    }
  };

  static getNavigationAssets = (module, size) => {
    let assets;
    switch (module) {
      case "account":
        const topAssetAccount =
          size && size === "md" ? NavTopAccountmd : NavTopAccount;
        assets = {
          top: topAssetAccount,
          bottom: NavBottomAccount,
        };
        break;
      case "billing":
        const topAssetBilling =
          size && size === "md" ? NavTopBillingmd : NavTopBilling;
        assets = {
          top: topAssetBilling,
          bottom: NavBottomBilling,
        };
        break;
      case "support":
        const topAssetSupport =
          size && size === "md" ? NavTopSupportmd : NavTopSupport;
        assets = {
          top: topAssetSupport,
          bottom: NavBottomSupport,
        };
        break;
      case "storage":
        const topAssetStorage =
          size && size === "md" ? NavTopStoragemd : NavTopStorage;
        assets = {
          top: topAssetStorage,
          bottom: NavBottomStorage,
        };
        break;
      case "colocation":
        assets = {
          top: NavTopColo,
          bottom: NavBottomColo,
        };
        break;
      default:
        assets = {
          top: NavTopStoragemd,
          bottom: NavBottomStorage,
        };

        return assets;
    }
    return assets;
  };

  /**
   * getNextSetFromList
   * This method is used to select the next set of items from the list of Billing invoices
   */
  static getNextSetFromList = (
    list,
    currentIndex,
    amtToReturn,
    initialLoad = false,
    stepSize = 1
  ) => {
    let index = initialLoad ? 0 : (currentIndex + stepSize) % list.length;
    const nextFour = [list[index]];
    const numToInclude = Math.min(list.length - 1, amtToReturn - 1);

    for (let i = 0; i < numToInclude; i++) {
      index = (index + 1) % list.length;

      nextFour.push(list[index]);
    }

    return nextFour;
  };

  /**
   * getPrevSetFromList
   * This method is used to select the previous set of items from the list of Billing invoices
   */
  static getPrevSetFromList = (
    list,
    currentIndex,
    amtToReturn,
    stepSize = 1
  ) => {
    let index =
      currentIndex - stepSize >= 0
        ? currentIndex - stepSize
        : list.length - stepSize;
    const prevFour = [list[index]];
    const numToInclude = Math.min(list.length - 1, amtToReturn - 1);

    for (let i = 0; i < numToInclude; i++) {
      index = (index + 1) % list.length;

      prevFour.push(list[index]);
    }

    return prevFour;
  };

  static sort(list) {
    return list.sort((a, b) => {
      return compareDesc(new Date(a.startDate), new Date(b.startDate));
    });
  }
  /**
   * getNextRowFromList
   * This method is used to select the next of set rows from the list of Ticket History list
   */
  static getNextRowFromList = (
    newList,
    currentIndex,
    amtToReturn,
    initialLoad = false,
    stepSize = 1,
    direction = TICKET_LIST_CYCLE_DIRECTION.NEXT,
    rows = 3,
    selected,
    selectTicketStatus,
    filterArrow
  ) => {
    const nextSet = [];
    let currIndex = currentIndex;
    let initial = initialLoad;
    const list = Utils.filterList(
      selected,
      selectTicketStatus,
      filterArrow,
      newList
    );

    let rowsToPopulate = list.length > amtToReturn ? rows : rows - 1;
    if (list.length <= 6) {
      rowsToPopulate = rows - 1;
    }
    if (list.length <= 3) {
      rowsToPopulate = rows - 2;
    }

    for (let i = 0; i < rowsToPopulate; i++) {
      let startingIndex = Utils.getNextIndex(
        direction,
        list,
        currIndex,
        initial,
        stepSize
      );
      if (!startingIndex) {
        startingIndex = 0;
      }
      const itemsToInclude = Math.min(
        list.slice(startingIndex, startingIndex + amtToReturn).length,
        amtToReturn
      );
      nextSet.push(list.slice(startingIndex, startingIndex + itemsToInclude));

      currIndex = startingIndex;
      // eslint-disable-next-line
      direction = TICKET_LIST_CYCLE_DIRECTION.NEXT;
      initial = false;
    }
    return nextSet;
  };

  /**
   * getNextIndex
   * Helper method for the getNextRowFromList method
   */
  static getNextIndex(direction, list, currentIndex, initialLoad, stepSize) {
    if (direction === TICKET_LIST_CYCLE_DIRECTION.NEXT) {
      return initialLoad || currentIndex + stepSize >= list.length
        ? 0
        : currentIndex + stepSize;
    } else {
      const amtToGet = list.length % stepSize || stepSize;

      return initialLoad || currentIndex - stepSize < 0
        ? list.length - amtToGet
        : currentIndex - stepSize;
    }
  }

  /**
   * downloadInstructionPdf
   * This method is used to download the Windows and/or Mac Storage Pdf instructions
   */
  static downloadInstructionPdf(name, data) {
    const urlObject = window.URL || window.webkitURL || window;
    const export_blob = new Blob([data]);

    if ("msSaveBlob" in navigator) {
      navigator.msSaveBlob(export_blob, name);
    } else if ("download" in HTMLAnchorElement.prototype) {
      const save_link = document.createElementNS(
        "http://www.w3.org/1999/xhtml",
        "a"
      );
      save_link.href = urlObject.createObjectURL(export_blob);
      save_link.download = name;
      Utils.fake_click(save_link);
    } else {
      throw new Error("Neither a[download] nor msSaveBlob is available");
    }
  }

  /**
   * Helper method for the Windows / MAC Pdf download method
   */
  static fake_click(obj) {
    const ev = document.createEvent("MouseEvents");
    ev.initMouseEvent(
      "click",
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
    obj.dispatchEvent(ev);
  }

  /**
   * Method to format a Date string
   */
  static formatDate(date) {
    // Strip all dashes from the date
    let formattedDate = "-";
    const rawDate = date.replace(/-/g, "");
    const incomingDateFormat = /([\d]{2})([\d]{2})([\d]{4})/;
    const dateMatch = incomingDateFormat.exec(rawDate);

    if (dateMatch) {
      /* Only represent two digit year */
      const year = dateMatch[3].substr(2);
      formattedDate = `${dateMatch[1]}.${dateMatch[2]}.${year}`;
    }

    return formattedDate;
  }

  static formatInvoiceDate(date) {
    try {
      return format(new Date(date), "MM.dd.yy");
    } catch (e) {
      console.log(e);
      return date;
    }
  }

  static formatAmount = (newAmount) => {
    let amount = newAmount;
    amount = amount.replace("$", "");
    amount = amount.replace(",", "");
    amount = parseFloat(amount);
    if (isNaN(amount)) {
      return 0;
    }

    return amount;
  };

  static formatCurrency(amount) {
    let amountWithoutCommas = amount;
    if (typeof amountWithoutCommas === "string") {
      amountWithoutCommas = amountWithoutCommas.replace(",", "");
    }

    return Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    })
      .format(amountWithoutCommas)
      .replace("$", "");
  }

  static scalePxUsingVh(px, screenHeightMax = 1440) {
    // const screenHeightMax = 1440;
    const currentScreenHeight = window.innerHeight;

    return (px / screenHeightMax) * currentScreenHeight;
  }

  static scalePxUsingVw(px, screenWidthMax = 2560) {
    // const screenWidthMax = 2560;
    const currentScreenWidth = window.innerWidth;

    return (px / screenWidthMax) * currentScreenWidth;
  }
  static getRequester(auth_status) {
    const firstName = auth_status.user.firstname;
    const lastName = auth_status.user.lastname;
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    } else {
      return "";
    }
  }

  static scalePxUsingRatio() {
    return window.innerHeight / 57;
  }

  static getElementAttribute(el, attr, asNum = true) {
    if (!el || !attr) {
      return null;
    }

    const element = document.querySelector(`.${el}`);
    if (element) {
      const style = window.getComputedStyle(element);
      let value = style.getPropertyValue(attr);

      if (asNum) {
        value = value.replace(/[^\d\.]/g, "");
        return parseFloat(value);
      } else {
        return value;
      }
    } else {
      return null;
    }
  }

  static SUPPORTED_RATIOS = {
    lg: 2560 / 1440,
    md: 1440 / 1024,
    sm: 1024 / 800,
  };
  static scrubPhoneNumberDots(number) {
    let scrubbedNumber = "";
    try {
      scrubbedNumber = number
        .replace(".", "")
        .replace(".", "")
        .replace(/_/g, "");
    } catch (e) {
      console.log(e);
    }
    return scrubbedNumber;
  }

  static scrubPhoneNumber(number) {
    let scrubbedNumber = "";
    try {
      scrubbedNumber = number
        .replace("(", "")
        .replace(")", "")
        .replace(/\s+/g, "")
        .replace("-", "");
    } catch (e) {
      console.log(e);
    }

    return scrubbedNumber;
  }

  static isValidResponse(response) {
    return response.status === 200 && !response.data.error;
  }

  static truncateString(text, characters = 8) {
    if (!text) {
      return null;
    }

    // Save space for 3 ellipsis, if needed
    const numOfCharacters = characters - 3;
    const shouldAddEllipsis = text.length > numOfCharacters;

    return `${text.slice(0, numOfCharacters)}${shouldAddEllipsis ? "..." : ""}`;
  }

  static splitIp = (ip) => {
    const regex = /(\d*)\.(\d*)\.(\d*)\.(\d*)\/(\d*)/;
    let matches = [];
    if (ip) {
      matches = ip.match(regex);
    }

    return matches && matches[0]
      ? { pieces: matches.slice(1, 5), subnet: matches[5] }
      : { pieces: [], subnet: null };
  };

  static convertIpToInt = (ip) => {
    return (
      ip.split(".").reduce((int, oct) => (int << 8) + parseInt(oct, 10), 0) >>>
      0
    );
  };

  static isIp4InCidr = (ip, cidr) => {
    const [range, bits = 32] = cidr.split("/");
    const mask = ~(2 ** (32 - bits) - 1);
    const validity =
      (Utils.convertIpToInt(ip) & mask) ===
      (Utils.convertIpToInt(range) & mask);
    return { validity, msg: validity ? "" : "Invalid address" };
  };

  static checkIsValidNetworkId = (ip) => {
    try {
      const cidr = new Netmask(ip);
      const ipPortion = ip.replace(/\/\d+/, "");
      const networkId = cidr.base;

      const msg = ipPortion === networkId ? "" : "Invalid network ID";

      return { validity: ipPortion === networkId, msg };
    } catch (e) {
      console.log(e);
      return { validity: false, msg: "" };
    }
  };

  static checkSubnetValidity = (subnet) => {
    return (
      typeof subnet === "undefined" ||
      subnet === "" ||
      subnet === null ||
      (parseInt(subnet) && parseInt(subnet) <= 32 && parseInt(subnet) >= 24)
    );
  };

  static checkIpValidity = (pieces, subnet, dirty) => {
    if (dirty === undefined || dirty === null) {
      return { validity: true, msg: "" };
    }
    let msg = "";
    const everyOctetIsNum = pieces.every(
      (piece, index) =>
        !dirty[index] ||
        (dirty[index] && parseInt(piece) >= 0 && parseInt(piece) < 256)
    );
    const firstOctetValid =
      !dirty[0] ||
      (dirty[0] && pieces[0] && parseInt(pieces[0]) && parseInt(pieces[0]) > 0);
    const subnetValid = Utils.checkSubnetValidity(subnet);

    if (!everyOctetIsNum) {
      msg = "Octects can only be numbers between 0 and 256";
    } else if (!firstOctetValid) {
      msg = "First octect should be a number above 0";
    } else if (!subnetValid) {
      msg = "Invalid subnet";
    }

    return { validity: everyOctetIsNum && firstOctetValid && subnetValid, msg };
  };

  static checkListOfIps = (ips) => {
    const dirtyMapping = new Array(ips.length).fill(true);
    /** Are all Ips valid based on valid octets? */
    return ips.reduce((valid, ip) => {
      const { pieces, subnet } = Utils.splitIp(ip);
      const { validity: octectsValid } = Utils.checkIpValidity(
        pieces,
        subnet,
        dirtyMapping
      );
      const { validity: networkIdValid } = Utils.checkIsValidNetworkId(ip);
      const allValid = octectsValid && networkIdValid;

      return valid && allValid;
    }, true);
  };

  static attachSubnetToIps = (ips) => {
    return ips
      ? ips.map((ip) => {
          return /\/$/.test(ip) ? `${ip}32` : ip;
        })
      : [];
  };

  /**
   * **************************************************
   * Calculations used to find menu gradient percentage
   * **************************************************
   */
  static createLine = (pointOne, pointTwo) => {
    if (!pointOne || !pointTwo) {
      return null;
    }

    // Calculate line slope
    const yDiff = pointTwo.y - pointOne.y;
    const xDiff = pointTwo.x - pointOne.x;
    const slope = yDiff / xDiff;

    // Calculate y intercept
    const yIntercept = pointOne.y - slope * pointOne.x;

    return { line: { slope, yIntercept } };
  };

  static findCrossPoint = (line1, line2) => {
    if (!line1 || !line2) {
      return null;
    }

    const yInterceptDiff = line1.yIntercept - line2.yIntercept;
    const slopeDiff = line2.slope - line1.slope;
    const x = yInterceptDiff / slopeDiff;
    const y = line1.slope * x + line1.yIntercept;

    return {
      crossPoint: {
        point: { x, y },
      },
    };
  };

  static mapCGStatus(status) {
    switch (status) {
      case "Unsubmitted":
        return "Reviewing";
      case "New":
        return "Reviewing";
      case "Pending Close":
        return "In Review";
      case "Waiting for Details":
        return "Needs Info";
      case "Customer Note Added":
        return "In Progress";
      case "Pending Resolution":
        return "In Review";
      default:
        return status;
    }
  }

  static findCrossPointPercentage = (
    fromPoint,
    toPoint,
    { point: crossPoint }
  ) => {
    if (!fromPoint || !toPoint || !crossPoint) {
      return null;
    }

    const xRange = toPoint.x - fromPoint.x;
    const crossPointRange = crossPoint.x - fromPoint.x;

    return crossPointRange / xRange;
  };

  static getElementPoints = (element) => {
    const el = document.querySelector(`.${element}`);

    if (el) {
      const boundingRect = el.getBoundingClientRect();
      return {
        points: {
          left: {
            x: boundingRect.left,
            y: boundingRect.top + boundingRect.height / 2,
          },
          right: {
            x: boundingRect.left + boundingRect.width,
            y: boundingRect.top + boundingRect.height / 2,
          },
          top: {
            x: boundingRect.left + boundingRect.width / 2,
            y: boundingRect.top,
          },
          bottom: {
            x: boundingRect.left + boundingRect.width / 2,
            y: boundingRect.top + boundingRect.height,
          },
        },
      };
    }

    // return null;
    return { points: null };
  };

  static calculateGradientPath = (topEl, bottomEl, side) => {
    if (!topEl || !bottomEl) {
      return null;
    }
    // Get DOM elements and relative points of the element
    const { points: topDiamondPoints } = Utils.getElementPoints(topEl);
    const { points: bottomDiamondPoints } = Utils.getElementPoints(bottomEl);

    if (!topDiamondPoints || !bottomDiamondPoints) {
      return null;
    }

    // Get line1 and line2 points based on sides being analyzed
    const lineOneFromPoint =
      side === SIDES.LEFT ? topDiamondPoints.left : topDiamondPoints.right;
    const lineOneToPoint = bottomDiamondPoints.bottom;
    const lineTwoFromPoint =
      side === SIDES.LEFT
        ? bottomDiamondPoints.left
        : bottomDiamondPoints.right;
    const lineTwoToPoint = bottomDiamondPoints.top;

    // Create line objects for menu and bottom diamond elements
    const { line: lineOne } = Utils.createLine(
      lineOneFromPoint,
      lineOneToPoint
    );
    const { line: lineTwo } = Utils.createLine(
      lineTwoFromPoint,
      lineTwoToPoint
    );

    // Find cross point between both lines and calcuate cross point percentage
    const { crossPoint } = Utils.findCrossPoint(lineOne, lineTwo);
    const crossPointPercentage = Utils.findCrossPointPercentage(
      lineOneFromPoint,
      lineOneToPoint,
      crossPoint
    );

    return {
      gradientLine: lineOne,
      percentage: crossPointPercentage,
      crossPoint: crossPoint.point,
    };
  };
  static isEqual = (value, other) => {
    // Get the value type
    const type = Object.prototype.toString.call(value);

    // If the two objects are not the same type, return false
    if (type !== Object.prototype.toString.call(other)) return false;

    // If items are not an object or array, return false
    if (["[object Array]", "[object Object]"].indexOf(type) < 0) return false;

    // Compare the length of the length of the two items
    const valueLen =
      type === "[object Array]" ? value.length : Object.keys(value).length;
    const otherLen =
      type === "[object Array]" ? other.length : Object.keys(other).length;
    if (valueLen !== otherLen) return false;

    // Compare properties
    if (type === "[object Array]") {
      if (!Utils.compareObjectArray(valueLen, value, other)) {
        return false;
      }
    } else {
      if (!Utils.compareKey(key, value, other)) {
        return false;
      }
    }

    // If nothing failed, return true
    return true;
  };

  static compareObjectArray = (key, value, other) => {
    let match = false;
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        if (Utils.compare(value[key], other[key]) === false) {
          match = false;
        } else {
          match = true;
        }
      }
    }
    return match;
  };

  static compareKey = (valueLen, value, other) => {
    let match = false;
    for (let i = 0; i < valueLen; i++) {
      if (Utils.compare(value[i], other[i]) === false) {
        match = false;
      } else {
        match = true;
      }
    }
    return match;
  };

  // Compare two items
  static compare = (item1, item2) => {
    // Get the object type
    const itemType = Object.prototype.toString.call(item1);

    // If an object or array, compare recursively
    if (["[object Array]", "[object Object]"].indexOf(itemType) >= 0) {
      if (!this.isEqual(item1, item2)) return false;
    }

    // Otherwise, do a simple comparison
    else {
      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) return false;

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === "[object Function]") {
        if (item1.toString() !== item2.toString()) return false;
      } else {
        if (item1 !== item2) return false;
      }
    }
  };
}

export const setNewContentAvailable = (needsUpdate) => {
  try {
    sessionStorage.setItem(`newContentAvailable`, needsUpdate);
  } catch (e) {
    console.log(e);
    return false;
  }

  return true;
};

export const checkIfNewContentAvailable = () => {
  let currentMembership;
  try {
    currentMembership = JSON.parse(
      sessionStorage.getItem(`newContentAvailable`)
    );
  } catch (e) {
    console.log(e);
    return null;
  }

  return currentMembership;
};
